import React from 'react'
import { useTranslation } from 'react-i18next'
import { Separator, Row, BillboardButton, Image, LayoutBand, H3, H5, Paragraph, useContainerWidth } from '@fs/zion-ui'
import { useUser } from '@fs/zion-user'
import { useCurrentTemple } from '../../hooks'

const NotAvailable = () => {
  const { t } = useTranslation()
  return <span style={{ fontStyle: 'italic' }}>{t('common.not-available', 'Not available')}</span>
}

const PrayerRoll = ({ prayerRollUrl }) => {
  const { t } = useTranslation()
  return (
    <section>
      <Row>
        <H5>{t('temple.info.prayer-roll', 'Prayer Roll')}</H5>
      </Row>
      <Row>
        {prayerRollUrl ? (
          <BillboardButton emphasis="medium" to={prayerRollUrl} target="_blank">
            {t('temple.info.submit-names', 'Submit Names')}
          </BillboardButton>
        ) : (
          <NotAvailable />
        )}
      </Row>
    </section>
  )
}

const ApptBtn = ({ apptUrl, t }) => (
  <section>
    <BillboardButton fullWidth emphasis="high" to={apptUrl} target="_blank">
      {t('temple.appointment.action', 'Make an Appointment')}
    </BillboardButton>
  </section>
)

export default function MyTemple() {
  const [t] = useTranslation()
  const user = useUser()
  const { temple } = useCurrentTemple({ loading: user?.loading, signedIn: user?.signedIn })
  const atWidth = useContainerWidth()
  const { urls } = temple || {}
  const templeImageUrl = atWidth({ default: urls?.mediumUrl, lg: urls?.largeUrl })

  const prayerRollUrl = 'https://www.churchofjesuschrist.org/temples/prayer-roll'
  const apptUrl = 'https://www.churchofjesuschrist.org/temples/schedule/appointment'

  const notAvailableText = t('common.not-available', 'Not available')

  return (
    <main>
      <LayoutBand maxWidth="xs">
        <Separator />
        <section>
          <H3>{temple?.localizedName ?? notAvailableText}</H3>
          <Separator />
        </section>
        <Image src={templeImageUrl} alt={t('temple.picture.alt', 'A picture of a Temple')} positionY="top" />
        <Separator />
        <H5>{t('informational.temple.my-temple.location', 'Location')}</H5>
        <Paragraph>{temple?.location ?? notAvailableText}</Paragraph>
        <Separator />
        <H5>{t('informational.temple.my-temple.dedicated', 'Dedicated')}</H5>
        <Paragraph>{temple?.dedicationDate ?? notAvailableText}</Paragraph>
        <Separator />
        <PrayerRoll prayerRollUrl={prayerRollUrl} />
        <Separator size="lg" />
        <ApptBtn apptUrl={apptUrl} t={t} />
        <Separator size="lg" />
      </LayoutBand>
    </main>
  )
}
